module.exports = "https://cdn.realtymogul.com/static/media/icon_pdf.fcfcdb29.svg";